module.exports = __webpack_public_path__ + "img/2018-logo-igarape-branco-PT.f18234c4.png";